import { Component, ViewEncapsulation } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'app-button-renderer-profile',
    templateUrl: './button-renderer-profile.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ButtonRendererProfileComponent implements ICellRendererAngularComp {
    //Xeroaction: string = "XeroAction";
    viewdetailaction: string = "ViewDetailAction";
    actionButtons: any[] = [];
    params: ICellRendererParams;
    data: any = {};
    buttontext: string = '';
    constructor(
        private translate: TranslateService
    ) { }

    onUserAction(action) {
        this.params.data.userAction = action;
        this.params.node.setData(this.params.data);
        this.params.eGridCell.click();     
    }

    initilize(params: ICellRendererParams) {
        if (params && params.data) {
            this.buttontext = params.getValue();
            this.params = params;
        }
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}